import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import Loading from '../../../../../components/common/Loading';
import ORBApi from '../../../../../services/ORBApi';
import { GraphColors } from './GraphOptions';
import moment from 'moment';
import 'moment/locale/pt-br';

const WorksMonthlyRevenueGraph = ({ language, filters, currency }) => {
  const [date, setDate] = useState([]);
  const [valueDate, setValueDate] = useState([]);
  const [fileProcessing, setFileProcessing] = useState(0);
  const [requestSource, setRequestSource] = useState(null);

  moment.locale(language);

  const doSearch = () => {
    if (fileProcessing) {
      // if there is a request processing, cancel it
      ORBApi.abortRequest(requestSource);
    }
    setFileProcessing(1);
    // Get the request abort source, to be used to cancel the request if needed
    var cancelRequestSource = ORBApi.getRequestAbortSource();
    setRequestSource(cancelRequestSource);
    ORBApi.loadWorkMonthlyRevenue(
      filters.startDate,
      filters.endDate,
      filters.dateType,
      filters.workId,
      filters.contributorId,
      filters.publisher,
      cancelRequestSource,
    )
      .then((data) => {
        if (!data || !data.months) {
          setDate([]);
          setValueDate([]);
          setFileProcessing(0);
          return;
        }
        setDate(data.months.map((i) => i?.date || ''));
        setValueDate(data.months.map((i) => i?.value || 0));
        setFileProcessing(0);
      })
      .catch((error) => {
        if (!ORBApi.isCancel(error)) {
          // When cancelling the request, do not remove the "loading"
          setFileProcessing(0);
        }
      });
  };

  useEffect(() => {
    doSearch();
  }, [filters]);

  return (
    <div>
      {fileProcessing ? (
        <Loading className="file-loading-container" />
      ) : date.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Sem dados para exibir
        </div>
      ) : (
        <Line
          data={{
            labels: date,
            datasets: [
              {
                data: valueDate,
                fill: false,
                borderColor: GraphColors[0],
                backgroundColor: GraphColors[4],
                tension: 0.1,
              },
            ],
          }}
          options={{
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return context.parsed.y.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: currency,
                    });
                  },
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  callback: function (value, index, values) {
                    return value.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: currency,
                    });
                  },
                },
              },
              x: {
                ticks: {
                  callback: function (value, index, ticks) {
                    if (value && typeof value === 'string') {
                      return moment(value).format('MMM/YY');
                    }
                    return value;
                  },
                },
              },
            },
          }}
        />
      )}
    </div>
  );
};

export default WorksMonthlyRevenueGraph;
